module.exports = __webpack_public_path__ + "img/heart_10_bj.24ede4ed.png";